//@flow

export const PHOTOSHOOTING_SAVED: 'photshooting/saved' = 'photshooting/saved';

export type Action = { type: typeof PHOTOSHOOTING_SAVED, photoshooting: any };
